/*
{
  url: string -- 이동하려는 주소('/project/1') 또는 라우터 이름({name:'', params:{id:1}})
}
*/
export default [
  {
    url: {name: 'project-home', params:{proj_id: 1}},
    name: '총괄관리',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: '총괄관리',
  },
  {
    url: {name: 'project-home', params:{proj_id: 2}},
    name: 'Premium Ver',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: 'Premium Ver',
  },
  {
    url: {name: 'project-home', params:{proj_id: 3}},
    name: 'Data Base Team',
    icon: 'FileTextIcon',
    activeCode: '',
    project_type: 'Data Base Team',
  },
  {
    url: {name: 'project-home', params:{proj_id: 4}},
    name: '파트너입찰(1억이하)',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '파트너입찰(1억이하)',
  },
  {
    url: {name: 'project-home', params:{proj_id: 5}},
    name: '파트너입찰(1억이상)',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '파트너입찰(1억이상)',
  },
  {
    url: {name: 'project-home', params:{proj_id: 6}},
    name: '삼성 에스원',
    icon: 'ShieldIcon',
    activeCode: '',
    project_type: '삼성 에스원',
  },
]
